import Idioma from '../Idioma'
export default new Idioma({
  idioma:'fr',
  pasos: {
    uno: 'Faites votre réservation',
    dos: 'Services souhaités',
    tres: 'Données personnelles',
    cuatro: 'Résumé et paiement'
  },
  resumen:{
    para: 'pour',
    personas: 'personne(s)',
    entrada: 'Arrivée:',
    salida: 'Départ:'
  },
  datosReserva:{
    selecciona: 'Sélectionnez le type d\'hébergement',
    sistema: 'Système de réservation',
    antes: 'Informez-vous avant de réserver',
    textoAntes:[
      'Lisez attentivement toutes les indications données au cours des différentes étapes pour effectuer au mieux votre réservation.',
      'Après avoir effectué votre réservation en ligne, vous recevrez un e-mail contenant le code et les détails de votre réservation. Ne le perdez pas, vous en aurez besoin pour réaliser tout type de modification de la réservation.',
      'Pour annuler une réservation, vous devrez contacter l\'établissement.',
      'Dans les encadrés "Observations", vous pourrez nous laisser tout commentaire que vous jugerez nécessaire. Chaque information supplémentaire nous aidera à mieux répondre à votre demande.',
      'Rappelez-vous que (dans la mesure des places disponibles) vous disposez d\'un temps limité pour effectuer la réservation (le système bloque les places demandées jusqu\'à ce que vous versiez le paiement par avance de la somme indiquée). Si vous dépassez ce délai, le système annulera votre demande et vous devrez recommencer la procédure de réservation.',
    ],
    fechas:'Informations relatives aux dates',
    textoFechas:[
      'Si vous souhaitez réserver pour le jour même ou pour le lendemain, vous ne pourrez pas effectuer la réservation en ligne, vous devrez contacter directement l\'établissement.',
      'Le nombre maximum de nuits disponibles à la réservation en ligne est de 4 nuits.'
    ],
    numeroPlazas: 'Nombre de places',
    plazasSelect:'Sélectionnez le nombre de personnes',
    plazas:'Informations relatives aux places',
    textoPlazas:[
      'Le système de réservation en ligne dispose d\'un nombre limité de places pour chaque établissement. Si vous ne pouvez pas réserver en ligne, contactez directement l\'établissement par téléphone.',
      'Dans la plupart des établissements de ce moteur de réservation, les places proposées correspondent à des chambres partagées. Si vous souhaitez un autre type d\'hébergement, veuillez contacter directement l\'établissement.'
    ],
    multiple:{
      cabecera:'Système de réservations multiples:',
      texto:'Consultez les disponibilités pour le premier refuge et utilisez cet outil pour planifier votre itinéraire.'
    },
    otro:'Souhaitez-vous ajouter un autre refuge à votre réservation?',
    seleccionaOtro:'Sélectionnez un autre établissement',
    otroBtn: 'Ajouter à la réservation',
    errorReserva:'Vérifiez les dates sélectionnées ou le nombre de personnes.',
    continuar:'Continuer',
    errors:{
      cerrado:'Les jours de fermeture ne peuvent pas être sélectionnés.',
      completo: 'Les jours complets ne peuvent pas être sélectionnés comme date d’arrivée.',
      online: 'Pour réserver cette date, veuillez contacter directement l’établissement.',
      salida: 'Les jours de fermeture ne peuvent pas être sélectionnés comme date de départ.',
      rango: 'Les conditions requises pour effectuer la réservation ne sont pas remplies.',
      personas: {
        principio: 'Il n’est pas possible de réserver ',
        final: ' places pour la date du:'
      }
    }
  },
  datosServicios:{
    selecciona:'Sélectionnez les services',
    fecha: 'Date',
    desayuno: 'Petit-déjeuner',
    comida: 'Repas de midi',
    picnic: 'Pique-nique',
    cena: 'Dîner',
    pernocta: 'Nuitée',
    observaciones: 'Ajoutez dans cet encadré tout commentaire que vous jugez nécessaire à propos du service que vous allez réserver.',
    btnReserva: 'Poursuivre la réservation',
    btnCancelar: 'Annuler la réservation',
    cerrarCancelar: 'Poursuivre la réservation',
    confirmarCancelar: 'Annuler la réservation',
    textoCancelar: 'Voulez-vous annuler cette réservation ?',
    infoCabecera:'Informations relatives aux services',
    info:'Si, le jour d\'entrée, vous prévoyez d’arriver après 19h, prenez contact avec l\'établissement pour savoir si vous pouvez réserver le dîner pour cette date.\n',
    otrosServicios:{
      otros:'Autres services'
    }
  },
  datosResumen:{
    resumen: 'Résumé de votre réservation',
    entrada: 'Date d’arrivée:',
    salida: 'Date de départ:',
    distintos: 'Services autres que les nuitées',
    dia: 'Date',
    totalAdelanto: 'Montant total du paiement par avance à effectuer par refuge',
    total: 'Montant total de la somme à verser par avance pour la réservation:',
    textoAdelanto:[
      'Ce montant ne constitue qu’un paiement partiel permettant de procéder à la réservation. Pour connaître le montant total de la réservation, consultez les tarifs des établissements sur leur site Internet. Nous vous rappelons que les tarifs réduits pour licenciés s\'appliquent uniquement aux personnes licenciées auprès de la FEDME ou des organismes affiliés à la Convention européenne de réciprocité des refuges.'
    ],
    pago: 'S’identifier et payer',
    tiempoRestante: 'Temps restant pour terminer la réservation:',
    tiempoFin:'Le délai pour effectuer la réservation s’est écoulé.',
    plazas:'Nombre de places',
    noches:'Nombre de nuits',
    AceptarBtn:'Accepter et payer',
    CancelarBtn:'Annuler la réservation',
    cerrarCancelar: 'Poursuivre la réservation',
    confirmarCancelar: 'Annuler la réservation',
    textoCancelar: 'Voulez-vous annuler cette réservation ?'
  },
  datosPersonales:{
    intro: 'Si vous êtes déjà enregistré, l\'utilisateur des alberguesyrefugios.com',
    mensaje: ['Vous aurez un accès rapide et sans effort', 'à vos informations'],
    opcion: 'Vous pouvez également',
    continuar: 'continuer sans vous inscrire',
    nombre:'Prénom',
    apellidos:'Nom',
    dni:'Numéro de pièce d’identité',
    fnac:'Date de naissance',
    direccion:'Adresse',
    cp:'Code postal',
    poblacion:'Commune',
    provincia:'Province',
    pais:'Pays',
    tfno:'Téléphone',
    club:'Club d’affiliation',
    correoe:'Adresse e-mail',
    confirmar:'Confirmer l’adresse e-mail',
    registro:'Souhaitez-vous créer votre compte sur notre plateforme de réservation en utilisant ces données?',
    observaciones: 'Ajoutez dans cet encadré tout commentaire que vous jugez nécessaire à propos du service que vous allez réserver.',
    tarjetainfo: 'J\'ai lu les informations relatives à l’utilisation de la carte de licencié (« Tarjeta federativa ») dans les refuges FAM.',
    infoTarjetaCabecera:'Informations relatives aux cartes de licenciés',
    infoTarjeta:'Dans les refuges et abris gérés par la FAM, seule la présentation de la carte fédérative de cette communauté qui se trouve dans l\'accord de correspondance mutuelle des refuges, soit la licence régionale ou nationale, sera acceptée comme preuve d\'être Fédéré (et donc avoir une réduction sur les prix).',
    informacion:'Je souhaite recevoir des informations et des actualités concernant les refuges et les auberges.',
    conformidad: {
      acepto:'J\'accepte les',
      y:'et la'
    },
    condiciones:'conditions de réservation',
    proteccion: {
      acepto: 'J\'accepte le',
      datos:'politique de protection des données'
    },
    AceptarBtn:'Accepter et payer',
    CancelarBtn:'Annuler la réservation',
    cerrarCancelar: 'Poursuivre la réservation',
    confirmarCancelar: 'Annuler la réservation',
    textoCancelar: 'Voulez-vous annuler cette réservation ?',
    legal:{
      condiciones:{
        titulo:'TERMES ET CONDITIONS POUR LA RÉSERVATION EN LIGNE',
        generales: {
          titulo: 'Modalités et conditions',
          texto:[
            'Le fait d\'effectuer une réservation implique l\'acceptation du règlement de fonctionnement et des horaires d\'ouverture de l\'établissement pour lequel elle est effectuée.',
            'Les établissements qui apparaissent sur cette page sont pour la plupart des auberges et des refuges de montagne. Dans ce type d\'établissement, à quelques exceptions près, l\'hébergement se fait dans des chambres multiples partagées et, dans de nombreux cas, il est nécessaire d\'utiliser un sac de couchage ou autre.',
            'Dans de nombreux établissements, les menus servis sont fermés, et il n\'y a pas de possibilité de choisir entre différents plats ou un menu à la carte.',
            'Il est nécessaire d\'avoir consulté la section "Comment s\'y rendre" avant de faire une réservation, car certains refuges sont situés en haute altitude et ne peuvent être atteints qu\'à pied.',
            'Pour annuler une réservation, vous devez contacter l\'établissement.'
          ]
        },
        anticipo: {
          titulo: 'Réservation préalable',
          inicio: [
            'Pour effectuer une réservation en ligne, un acompte doit être versé à l\'avance. Le montant de cette somme dépend des services réservés.',
            'Les conditions de remboursement sont les suivantes :'
          ],
          lista:[
            'Si les réservations sont annulées dans les 6 jours précédant la date de réservation, 100 % de l\'acompte sera remboursé, moins les frais de retour et de moteur de réservation, le cas échéant.',
            'En cas d\'annulation dans les 5 derniers jours de la date de réservation, 100 % de l\'acompte total sera facturé.',
            'Les frais de remboursement sont de 1€ plus 0,25€ par personne et par nuitée jusqu\'à un maximum de 5€.'
          ],
          fin:[
            'En cas de "force majeure", 100 % de l\'acompte versé sera remboursé. Ce concept de "force majeure" devrait être examiné par le gardien de l\'établissement, qui déciderait si un cas d\'annulation de réservation est ou non un cas de "force majeure", et si le réservataire n\'est pas d\'accord avec la décision du gardien, il peut alors en référer à l\'organe de gestion.',
            'Dans les établissements de la F.A.M., il y a une limite de temps pour les arrivées afin de disposer de la place réservée. Si ces délais ne sont pas respectés, la place sera gratuite pour les utilisateurs qui en feront la demande. Consultez les conditions de la réglementation de chaque refuge.'
          ]
        }
      }
    },
    avisoLegal:{
      tituloGeneral:'Aviso legal',
      info:{
        titulo: 'Información legal',
        texto:[
          'En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico (LSSICE) presentamos la siguiente información:',
          '',
          'Razón Social: Federación Aragonesa de Montañismo',
          'Dirección: C/. Albareda 7, 4º 4ª, 50004. Zaragoza',
          'C.I.F.: V50120211',
          'Teléfono: 976227971',
          'E-mail: fam@fam.es',
          'Datos de la inscripción en el Registro de Federaciones: 05/3',
          '',
          'Razón Social: PRAMES S.A.',
          'Dirección: Camino de los Molinos, 32. 50015. Zaragoza.',
          'C.I.F: A50223031',
          'Teléfono: 976106170',
          'E-mail: lopd@prames.com',
          'Datos de la Inscripción en el Registro Mercantil: 10.086 Folio: 185 Tomo: 841',

        ]
      },
      proteccion:{
        titulo: 'Protection des données',
        texto:[
          '1. en remplissant le formulaire d\'inscription ou de contact, en envoyant un e-mail ou en nous appelant par téléphone, vos données personnelles deviennent la responsabilité de la société dont les coordonnées sont indiquées dans la section 1.',
          '2. Ces données sont utilisées pour répondre à votre demande ou requête dans les meilleurs délais car vous nous les fournissez librement et en connaissance de cause à cette fin.',
          'Nous communiquerons aussi commercialement par voie électronique avec nos clients en fonction de notre intérêt légitime à leur proposer des produits et services similaires à ceux qu\'ils ont initialement contractés auprès de nous.',
          'Pour d\'autres traitements ou finalités liés à la prestation de nos services ou au développement de notre activité, vous pouvez obtenir plus d\'informations dans la politique de confidentialité de PRAMES, S.A. ou les demander à notre adresse de contact.',
          '3. Les données personnelles collectées sur notre site internet sont traitées conformément aux exigences du Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 relatif à la protection des personnes physiques à l\'égard du traitement des données à caractère personnel et à la libre circulation de ces données.',
          '4. Une fois que les données ne sont plus nécessaires aux fins pour lesquelles elles ont été collectées, elles sont tenues à la disposition des administrations publiques compétentes pendant les périodes de conservation légales, c\'est-à-dire aussi longtemps que la loi nous oblige à les présenter. Une fois ces périodes écoulées, elles seront bloquées jusqu\'à ce que leur destruction ou leur suppression ultérieure soit possible.',
          '5. Vous pouvez exercer vos droits d\'accès, de rectification, de suppression, d\'opposition, de limitation et de portabilité des données à caractère personnel en présentant une copie d\'un document d\'identification à l\'adresse suivante : fam@fam.es.',
          '6. Vous pouvez révoquer le consentement donné pour l\'envoi de communications électroniques au moment de la réservation, à l\'adresse susmentionnée.',
          '7. Vous pouvez trouver plus d\'informations sur vos droits ou déposer une plainte auprès de l\'autorité de contrôle compétente à l\'Agence espagnole de protection des données http://www.agpd.es - C/ Jorge Juan, 6. 28001 - Madrid (901 100 099 - 912 663 517).'
        ]
      },
      limitacion:{
        titulo: 'Limitation de la responsabilité',
        texto: [
          '1. La Fédération Aragonaise d\'Alpinisme met à disposition le site web corporatif comme moyen de faire connaître ses activités et services, et de permettre le contact avec les membres. Les informations figurant sur le site web sont présentées uniquement à titre indicatif ou informatif et ne sont à aucun moment considérées comme contraignantes.',
          '2. L\'entité n\'est pas responsable des éventuels dommages informatiques que l\'utilisateur pourrait subir en visitant notre site web, étant entendu que ces dommages ne peuvent être imputés à l\'entité.',
          '3. L\'entité n\'est pas non plus responsable du contenu des sites gérés par des tiers qui sont liés à partir de la page web, et ces liens n\'impliquent pas l\'existence d\'un quelconque type de relation entre la Federación Aragonesa de Montañismo et ces tiers.'
        ]
      },
      propiedad:{
        titulo: 'Droits de propriété intellectuelle',
        texto: [
          '1. Tous les contenus de cette page web, y compris les textes, les dessins, les graphiques, les photographies, les images, les vidéos, la musique, les codes, la conception de ces derniers et toute autre création sont la propriété de Federación Aragonesa de Montañismo et de PRAMES SA ou de leurs propriétaires respectifs au moyen de la licence, de l\'autorisation ou de la cession de droits correspondante et sont protégés conformément à la législation sur la propriété intellectuelle et industrielle.',
          '2. En aucun cas, il ne sera compris que la mise à disposition du site web au public constitue une renonciation, une cession ou une licence des droits que la Federación Aragonesa de Montañismo et PRAMES, S.A. ont sur le contenu du site web.',
          '3. Toute utilisation du contenu de notre site web, y compris la modification, la copie, la reproduction, la transmission, etc. est interdite sans l\'autorisation écrite préalable de l\'organisation.'
        ]
      }
    },
    seguro: {
      titulo: 'Attention',
      texto: [
        'alberguesyrefugios.com utilise le paiement sécurisé.',
        'Avant de confirmer la réservation, vérifiez que l’option de paiement sécurisé de votre carte bancaire est activée.'
      ]
    },
    btnPagar:'Confirmer les données personnelles',

    errores:{
      nombre:'Ce champ est obligatoire. Le texte doit comprendre au minimum 3 caractères.',
      apellidos:'Ce champ est obligatoire. Le texte doit comprendre au minimum 3 caractères.',
      dni:'Ce champ est obligatoire. Le texte doit comprendre au minimum 3 caractères.',
      fnac:'Ce champ est obligatoire. Ce champ est obligatoire et vous devez avoir l\'âge légal',
      direccion:'Ce champ est obligatoire. Le texte doit comprendre au minimum 3 caractères.',
      cp:'Ce champ est obligatoire. Le texte doit comprendre au minimum 5 caractères.',
      poblacion:'Ce champ est obligatoire. Le texte doit comprendre au minimum 3 caractères.',
      provincia:'Ce champ est obligatoire. Le texte doit comprendre au minimum 3 caractères.',
      pais:'Ce champ est obligatoire. Le texte doit comprendre au minimum 3 caractères.',
      correo:'Ce champ est obligatoire. Le texte doit respecter le format d’une adresse e-mail.',
      confirmarCorreo:'Les adresses e-mail doivent correspondre.\n',
      tfno:'Ce champ est obligatoire. Le texte doit comprendre au minimum 3 caractères.'
    },
    login:{
      btnRegistrado:'se connecter',
      btnNuevo: 'je veux réserver',
      saludo:'Bonjour ',
      info:'Ces données seront utilisées pour effectuer la réservation. Les données de votre compte ne seront pas modifiées.',
      btnSalir:'Se déconnecter et annuler la réservation',
      cerrarCancelar: 'Poursuivre la réservation',
      confirmarCancelar: 'Annuler la réservation',
      textoCancelar: 'Voulez-vous annuler cette réservation ?',
      modal:{
        titulo:'S’identifier',
        olvido: 'Avez-vous oublié le mot de passe?',
        usuario:'Email',
        password:'Mot de passe',
        error: 'Nous n\'avons pas pu respecter ces données',
        btnCancelar:'Annuler',
        btnAceptar:'Accepter'
      }
    },
    covid: {
      pre:'J\'accepte les',
      anchor: 'nouvelles conditions',
      post: 'de COVID19'
    }
  }
});



// WEBPACK FOOTER //
// ./src/_locale/translations/fr.js